import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import * as RestService from '../../services/eisRest';
import DocumentWrRouteTemplateListTab  from '../../modules/wrRouteTemplate/DocumentWrRouteTemplateListTab';
import DocumentWrRouteTemplateTab  from '../../modules/wrRouteTemplate/DocumentWrRouteTemplateTab';



const DocumentWrRouteTemplate = (props) => {

    const [activeTab, setActiveTab] = useState('LIST');
    const [t] = useTranslation();
    //const [workOrder, setWorkOrderDocument] = useState();
    const [selectedRecord, setSelectedRecord] = useState();   
    const [checkTime, setCheckTime] = useState();
    

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

  

    const handleLoadedDocument = (workOrder) => {
       // setWorkOrderDocument(workOrder);
        setCheckTime(Date.now());
    }

    const handleDocumentSelected = (id,action) => {
        

                         if(id!=null && id!==''){
                            setSelectedRecord(id);
                            setActiveTab('DETAIL');                            
                         }else{
                            setSelectedRecord(Date.now());                          
                            setActiveTab('DETAIL');  
                            
                         }
    }

    return (
        <>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>{t('workOrder.label.wrRouteTemplate')}</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">
                                    <Link to="/">{t('workOrder.label.wrRouteTemplate')}</Link>
                                </li>
                                <li className="breadcrumb-item active">
                                    {t('workOrder.label.wrRouteTemplate')}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <div className="row"></div>
                            <div className="col-12 col-sm-12 col-lg-12" style={{margin: '0 auto',float: 'none'}}>
                                <div className="card card-primary card-outline card-tabs">
                                    <div className="card-header p-0 pt-1 border-bottom-0">
                                        <ul className="nav nav-tabs" role="tablist">
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'LIST'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        {
                                                            toggle('LIST');                                                                                                                        
                                                        }
                                                    }
                                                >
                                                    {t('document.label.list')}
                                                </button>
                                            </li>
                                            <li className="nav-item">
                                                <button
                                                    type="button"
                                                    className={`nav-link ${
                                                        activeTab === 'DETAIL'
                                                            ? 'active'
                                                            : ''
                                                    }`}
                                                    onClick={() =>
                                                        toggle('DETAIL')
                                                    }
                                                >
                                                    {t('workOrder.label.detail')}
                                                </button>
                                            </li>                                                                                     
                                        </ul>
                                    </div>
                                    <div className="card-body">
                                        <div className="tab-content">
                                            <DocumentWrRouteTemplateListTab                                             
                                                isActive={activeTab === 'LIST'}  
                                                parentCallback={handleDocumentSelected}
                                                checkTime={checkTime}      
                                            />                                                                                                                                                                           
                                            <DocumentWrRouteTemplateTab                                            
                                                isActive={activeTab === 'DETAIL'}  
                                                selectedRecord={selectedRecord}
                                                parentCallback={handleLoadedDocument}
                                            />                                                                                                                                                                
                                        </div>
                                    </div>
                                </div>   
                            </div>                         
                </div>
            </section>
        </>
    );
};

export default DocumentWrRouteTemplate;